import { Component, OnInit } from '@angular/core';
import { MatIconRegistry, MatSnackBar } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppSettings } from '../../app.constant';
import { InstitutionService } from '../../shared/services/institution.service';

@Component({
  selector: 'institution',
  templateUrl: './institution.component.html',
  styleUrls: ['./institution.component.css']
})

export class InstitutionComponent implements OnInit {
  httpResponseMessage: any;
  PK_InstitutionID: any = '';
  InstitutionCode: any = '';
  InstitutionName: string = '';
  Logo: string = '';
  Address: string = '';
  RegistrationNo: string = '';
  institutionForm: FormGroup;
  submitted = false;
  post: any;
  institutionentity: any;
  errorMessage: String;
  buttonTitle: String = 'S A V E ';
  newtitle: String = " N E W ";

  constructor(
    private FormBuilder: FormBuilder,
    private _institutionservice: InstitutionService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private snackBar: MatSnackBar) {
    iconRegistry.addSvgIcon(
      'thumbs-up',
      sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/left-arrow.svg'));
  }

  ngOnInit() {
    this.institutionForm = this.FormBuilder.group({
      'PK_InstitutionID': ['',],
      'InstitutionCode': ['', [Validators.required, Validators.maxLength(20)]],
      'InstitutionName': ['', [Validators.required, Validators.maxLength(250)]],
      'RegistrationNo': ['', [Validators.required, Validators.maxLength(20)]],
      'Address': ['', Validators.required],
      'Logo': ['',],
    })
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.institutionForm.controls[controlName].hasError(errorName);
  }

  postInstitution(post): void {
    if (post.PK_InstitutionID != '' && post.PK_InstitutionID != null) {
      this.updateInstitution(post);
    }
    else {
      this.createInstitution(post);
    }
  }

  updateInstitution(post) {
    if (this.institutionForm.invalid) {
      return;
    }
    this.post = JSON.stringify(post);
    this._institutionservice.updateInstitution(AppSettings.API_ENDPOINT + AppSettings.UpdateInstitution, this.post).subscribe(
      data => {
        this.httpResponseMessage = data;
        this.openSnackBar(this.httpResponseMessage, '');
        this.institutionForm.reset();
      },
      error => this.errorMessage = <any>error)
  }

  createInstitution(post): void {
    this.submitted = true;
    if (this.institutionForm.invalid) {
      return;
    }

    this.post = JSON.stringify(post);

    this._institutionservice.postInstitution(AppSettings.API_ENDPOINT + AppSettings.CreateInstitution, this.post).subscribe(
      data => {
        this.httpResponseMessage = data;
        this.openSnackBar(this.httpResponseMessage, '');
        this.institutionForm.reset();
      },
      error => this.errorMessage = <any>error)
  }

  receiveData($event) {
    this.institutionentity = $event
    this.InstitutionName = (this.institutionentity[0].InstitutionName).trim();
    this.InstitutionCode = (this.institutionentity[0].InstitutionCode).trim();
    this.PK_InstitutionID = this.institutionentity[0].PK_InstitutionID;
    this.Address = (this.institutionentity[0].Address).trim();
    this.RegistrationNo = this.institutionentity[0].RegistrationNo;
  }

  cleardata() {
    this.institutionForm.reset();
  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}
